export * from './amazon'

export const COOKIE_LINE_TOKEN = 'line_token'

export const COOKIE_ACCESS_TOKEN = 'access_token'

export const CUSTOMER_ID = 'customer_id'

export const PROVIDER = {
  CUSTOMER: 'customer',
  LINE: 'line',
}

export const SEX = {
  MALE: 1,
  FEMALE: 2,
}

export const CART_TYPE = {
  REGULAR: 'regular',
  PERIODIC: 'periodic',
}

export const MAX_AMOUNT_TOTAL = 999999999
export const AMAZON_TOKEN_KEY = 'amazon_Login_accessToken'

export const AMAZON_ERROR_CODE = {
  BUYER_SESSION_EXPIRED: 'BuyerSessionExpired',
}

export const FORMAT_DATE = 'yyyy/MM/dd'

export const FORMAT_DATE_JP = 'yyyy年MM月dd日'
export const FORMAT_DATE_JP_INCLUDE_DAY = 'yyyy年MM月dd日(EEEEEE)'
export const FORMAT_DATE_HYPHEN = 'yyyy-MM-dd'

export const PREFECTURES = [
  '北海道',
  '青森県',
  '岩手県',
  '宮城県',
  '秋田県',
  '山形県',
  '福島県',
  '茨城県',
  '栃木県',
  '群馬県',
  '埼玉県',
  '千葉県',
  '東京都',
  '神奈川県',
  '新潟県',
  '富山県',
  '石川県',
  '福井県',
  '山梨県',
  '長野県',
  '岐阜県',
  '静岡県',
  '愛知県',
  '三重県',
  '滋賀県',
  '京都府',
  '大阪府',
  '兵庫県',
  '奈良県',
  '和歌山県',
  '鳥取県',
  '島根県',
  '岡山県',
  '広島県',
  '山口県',
  '徳島県',
  '香川県',
  '愛媛県',
  '高知県',
  '福岡県',
  '佐賀県',
  '長崎県',
  '熊本県',
  '大分県',
  '宮崎県',
  '鹿児島県',
  '沖縄県',
]

export const PAYMENT_METHOD = {
  CREDIT_CARD: 1,
  DEFERRED_PAYMENT: 3,
  CASH_ON_DELIVERY: null,
  AMAZON: 2,
  NP: 4,
}

export const NUMBER_OF_PAYMENT = {
  BULK: 1,
}

export const PLACE_FIND_PRODUCT = {
  NEWSPAPER: 9,
  TV_COMMERCIAL: 10,
  ADVERTISEMENT_ON_THE_TRAIN: 11,
  FOLDED_LEAFLET: 12,
  ACQUAINTANCE_INTRODUCTION: 13,
  DIRECT_SALES_STORE: 14,
  BUNDLED_LEAFLET: 15,
  OTHERS: 'その他',
}

export const DATE_OPTIONS = {
  YEAR: Array.from({ length: 91 }, (_, index) => new Date().getFullYear() - 10 - index),
  MONTH: Array.from(Array(12).keys()).map((index) => index + 1),
  YEAR_CARD: Array.from(Array(11).keys()).map((index) => index + new Date().getFullYear()),
  DAY: Array.from(Array(31).keys()).map((index) => index + 1),
}

// export const DELIVERY_INTERVAL = [1, 2, 3]

export const DELIVERY_PATTERN = {
  MONTHLY_DATE_SPECIFICATION: 1,
  SPECIFY_WEEK_DAY_OF_WEEK: 2,
  SPECIFY_DELIVERY_DATE_INTERVAL: 3,
}

export const DELIVERY_DESTINATION = {
  DIFFERENCE_MEMBER: 1,
  SAME_MEMBER: 2,
}

export const DELIVERY_PATTERN_CHANGE = {
  MONTHLY_DATE_SPECIFICATION: 1,
  INTERVAL_DESIGNATION: 2,
  SPECIFY_DELIVERY_DATE_INTERVAL: 3,
}

// export const WEEK_NO = [1, 2, 3, 4]

export const DAY_OF_WEEK = {
  SUNDAY: 1,
  MONDAY: 2,
  TUESDAY: 3,
  WEDNESDAY: 4,
  THURDAY: 5,
  FRIDAY: 6,
  SATURDAY: 7,
}

// export const SPECIFY_DELIVERY_DATE_INTERVAL = [
//   10, 14, 15, 18, 20, 21, 23, 24, 25, 28, 30, 35, 36, 40, 42, 45, 48, 50, 54, 55, 60, 65, 70, 72, 75, 90, 120, 150, 180,
// ]

export const MASTER_DATA_KEY = [
  'pref',
  'where-did-you-know',
  'sex',
  'inquiry-category',
  'delivery-pattern-week-no',
  'delivery-pattern-day-of-week',
  'delivery-pattern-day',
  'delivery-pattern-month-day',
  'delivery-pattern-month',
  'delivery-note',
]

export const MASTER = {
  INQUIRY_CATEGORY: 'inquiry-category',
  PREF: 'pref',
  SEX: 'sex',
  WHER_DID_YOU_KNOW: 'where-did-you-know',
  SHIPPING_FEE: 'shipping-fee',
  FREE_AMOUNT: 'free-amount',
  PAYMENT_METHODS: 'payment-methods',
  DELIVERY_METHODS: 'delivery-methods',
  DELIVERY_ID: 'delivery-id',
  DELIVERY_PATTERN_DAY: 'delivery-pattern-day',
  DELIVERY_PATTERN_MONTH_DAY: 'delivery-pattern-month-day',
  DELIVERY_PATTERN_WEEK_NO: 'delivery-pattern-week-no',
  DELIVERY_PATTERN_DAY_OF_WEEK: 'delivery-pattern-day-of-week',
  DELIVERY_PATTERN_MONTH: 'delivery-pattern-month',
}

export const UNSPECIFIED_VALUE = '-'

export const SALE_TYPE = {
  NORMAL: 1,
  SUBSCRIPTION: 2,
  BOTH: 3,
}

export const CART_TYPES = {
  NORMAL: 0,
  SUBSCRIPTION: 1,
}

export const HOKKAIDO_ID = 1
export const DEFAULT_COUNTRY_ID = 392

export const LOCAL_CART = 'local-cart'
export const LOCAL_SUBSCRIPTION = 'local-subscription'
export const LOCAL_SUBSCRIPTION_AMAZON = 'local-subscription-amazon'

export const LINE_LINK_STATUS = {
  NO_LINE_ID: 1,
  EMAIL_NOT_YET_REGISTERED: 2,
}

export const SUBSCRIPTION_STATUS = {
  NORMAL: 1,
  SETTLEMENT_ERROR: 2,
  OUT_OF_STOCK: 3,
  OTHER_ERROR: 4,
  PAUSE: 5,
  CANCEL: 6,
}

export const POPUP_NAME = {
  ADDRESS: 'address',
  CARD: 'card',
}

export const ADD_TIMING_ID = 3

export const SHOP_CONFIG = {
  LOGO_URL: '/sh_cont/images/logo.svg',
  CART_URL: '/sh_cont/images/ic_cart.svg',
  MENU_URL: '/sh_cont/images/ic_menu.svg',
  LINE_ICON: '/sh_cont/images/line_icon.png',
  ATODENE_URL: '/sh_cont/images/atodene.png',
  BANK_CARD_URL: '/sh_cont/images/card.png',
  TRIANGLE: '/sh_cont/images/triangle.png',
  DEFRAYAL_EC_LINE004: `/sh_cont/parts/tokusyohou.html`,
  TERM_OF_USE_CONTENT: '/contents/terms-of-use-content.html',
  PRIVACY_CONTENT: '/contents/privacy-content.html',
  CANCELLATION: '/sh_cont/parts/cancellation.html',
  THANKS_LINE_CONTENT: '/sh_cont/parts/thanks_line_content.html',
  THANKS_CONTENT1: '/sh_cont/parts/thanks_content1.html',
  THANKS_CONTENT2: '/sh_cont/parts/thanks_content2.html',
  FOOTER: '/sh_cont/parts/footer.html',
  FOOTER2: '/sh_cont/parts/footer2.html',
  NP_URL: '/sh_cont/images/np_adv.png',
  LINE_CONTACT_MENU: '/sh_cont/images/line_contact.png',
  MAIL_CONTACT_MENU: '/sh_cont/images/mail_contact.png',
  LINE_ICON2: '/sh_cont/images/line_icon2.svg',
  BANNER_IMG: '/sh_cont/images/menu_banner.png',
  BANNER_IMG_SP: '/sh_cont/images/menu_banner_sp.png',
  BANNER_INQUIRY: '/sh_cont/parts/banner-inquiry.html',
  BANNER_INQUIRY_LINE: '/sh_cont/parts/banner-inquiry-line.html',
  PRIVACY_POLICY_URL: '/contents/privacy.html',
  TERMS_OF_USE_URL: '/contents/terms-of-use.html',
  FAQ_URL: '/contents/faq.html',
  BRAND_VISA: '/lpc_cont/images/brand_visa.png',
  BRAND_MASTER: '/lpc_cont/images/brand_master.png',
  BRAND_AMEX: '/lpc_cont/images/brand_amex.png',
  BRAND_DINNERCLUB: '/lpc_cont/images/brand_dinnerclub.png',
  BRAND_JCB: '/lpc_cont/images/brand_jcb.png',
  BRAND_DEFAULT: '/lpc_cont/images/brand_default.png',
  NOTICE_BOARD: '/sh_cont/parts/mypage_content1.html',
  PURCHASE_CONTENT1: '/sh_cont/parts/purchase_content1.html',
  PURCHASE_CONTENT2: '/sh_cont/parts/purchase_content2.html',
  NAVIGATION_ICON: '/lpc_cont/images/navigation_icon.png',
}

export const DEFAULT_REGION_ID = 13 // pref tokyo
export const SET_PROPERTIES = 'SET_PROPERTIES'
export const GET_PROPERTIES = 'GET_PROPERTIES'
export const EC_LINE003 = {
  TABS_TYPE: {
    NORMAL: 'normal',
    SUBSCRIPTION: 'subscription',
  },
}
export const EC_LINE009 = {
  TABS_TYPE: {
    NORMAL: 'normal',
    PAUSED: 'paused',
  },
  ERROR_TYPE: {
    CANCELED: 'ERROR_SUBSCRIPTION_HAS_ALREADY_BEEN_CANCEL',
  },
}
export const LIST_SECTION = {
  SUBSCRIPTION_SECTION: 'subscriptionSection',
  PAUSE_SECTION: 'pauseSection',
  PAYMENT_SECTION: 'paymentSection',
}

export const FRIEND_STATUS = {
  NOT_ADD: 1,
  PERMISSION: 2,
  ADD: 3,
  ADDED: 4,
}

export const AD_USER_ID = 'ad_user_id'

export const ADCD = 'adcd'

export const SAVE_ACCOUNT_STATUS_ERROR = {
  INVALID: 'ERROR_USER_CUSTOMER_LINE_EXISTS',
  NOT_FRIEND: 'ERROR_LINE_NOT_FRIEND',
  ADCD_INCORRECT: 'ERROR_ANALYSIS_GET_ADVERTISEMENT_CODE',
}

export const USER_STATUS = {
  LOGGED: 'logged',
  NOT_LOGGED: 'not-logged',
}

export const OS = {
  IOS: 'ios',
  ANDROID: 'android',
  WEB: 'web',
}

export const ACTION_LINE = {
  LOGIN_LINE: 'LOGIN_LINE',
}

export const SEX_UNKNOW = {
  ID: null,
  NAME: '無回答',
  SORT_NO: 0,
}

export const META_TAG = {
  NO_INDEX_NO_FOLLOW: 'noindex,nofollow',
}

export const DELIVERY_PATTERN_ACTION_TYPE = {
  NEXT_DELIVERY_DATE: 'next_delivery_date',
  NEXT_NEXT_DELIVERY_DATE: 'next_next_delivery_date',
  NEXT_DELIVERY_AUTO_CALCULATION: 'next_delivery_auto_calculation',
  NEXT_NEXT_DELIVERY_AUTO_CALCULATION: 'next_next_delivery_auto_calculation',
  PATTERN: 'pattern',
}

export const MAN_TO_YEN_CURRENCY = 10000

export const REOPEN_SUBSCRIPTION = {
  UPDATE_BEFORE: 1,
  NO_UDPATE_BEFORE: 2,
}
export const REDIRECT_LINE015_FLAG = {
  REDIRECT: 0,
  ADD_ITEM: 1,
}

export const BUNDLED_FLAG = {
  CANBE: true,
  NONE: false,
}

export const DELIVERY_FREE_TEXT_SORT_NO = 6

export const NEXT_NEXT_DIFF_MIN_DATE = 10

export const DIFF_MIN_NDD = 100

export const MAIL_DELIVERY_SERVICE = 'メール便'

export const PAYMENT_DIALOG_TYPE = {
  CHANGE_PAYMENT: 'changePayment',
  CHANGE_CARD: 'changeCard',
  EDIT_CARD: 'editCard',
}
export const TOAST_MESSAGE_DURATION = 5000

export const PATTERN = {
  NON_NUMERIC: /[^\d]/g,
  NUMERIC: /^\d+$/,
}

export const SUBS_INFO_REF = 'subscriptionInfo'

export const PURCHASE_INFO_REF = 'purchaseInfo'

export const ERROR_PAYMENT_REF = 'error-payment-{no}'

export const LINE_LOGIN_FROM_LOGIN_PAGE = 'by-login-line'

export const INQUIRY_STATUS_ID = {
  OPEN: 1,
  DURING_CORRESPOND: 2,
  DONE_CORRESPOND: 3,
  ON_HOLD: 4,
  URGENT: 5,
  COMPLETE: 6,
}

export const INQUIRY_TYPE_ID = {
  EMAIL: 1,
  PHONE: 2,
  LINE: 3,
}

export const APP_STATUS = {
  ERROR_UPDATE_PAYMENT_UNABLE: 50002,
  TOKEN_IS_EXPIRE: 8002,
  THIS_URL_HAD_BEEN_USED: 8003,
  TOKEN_MUST_NOT_BE_EMPTY: 8004,
}

export const FILE_PATH_TEMPLATE = 'template'

export const TEMPLATE_TYPE_NAME = {
  DELIVERY_SLIP: 'delivery-slip',
}

export const BUSINESS_ACCOUNT_FLAG = {
  PERSONAL: false,
  BUSINESS: true,
}

export const CARD_DEFAULT_FLAG = {
  DEFAULT: '1',
  NON_DEFAULT: '0',
}
